import { Box, Typography } from "@mui/material";


const Predicate = () => {

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Typography
                    fontWeight={"bold"}
                    fontFamily={"Inter"}
                    fontSize={"16px"}
                    color={"#303030"}
                >
                    Predicate
                </Typography>
            </Box>
        </>
    )
}
export default Predicate;